export default "__VITE_ASSET__DTwUOeoe__"